import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import AddIcon from "@mui/icons-material/Add";
import { LocalGasStation } from "@mui/icons-material";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import RegularButton from "components/CustomButtons/Button";
import { ModalV2 } from "components/Modal/ModalV2";
import { useSearch } from "hooks/useSearch";
import { useToggle } from "hooks/useToggle";
import { AddCarburetion } from "./AddCarburetion";
import { columns } from "./columns";
import { carburationsSelector } from "./selector";
import { validateObject } from "helpers/validateObject";
import { getCarburation, carburationInputsSearch, getUnitConfigs } from "redux/actions/carburetions/carburetionAction";
import { Typography } from "@mui/material";
import { formatNumber } from "helpers/getNumberFormats";


const tableKey = "carburations";

export const CarburetionPage = () => {
  const dispatch = useDispatch();
  const carburations = useSelector(state => carburationsSelector(state));
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);
  const { startDate, endDate, station, realCarburetionTotal } = useSelector(({ carburations }) => carburations);
  const {
    buildCompLoadings,
    buildTableConfig,
    setSnackbar,
    restoreTable
  } = useSearch();

  const [open, setOpen] = useToggle();

  const handleSubmit = e => {
    e.preventDefault();
    if(!station) return setSnackbar("No se ha seleccionado una planta.", "warning")
    if (!startDate) {
      setSnackbar("No se ha seleccionado fecha de inicio.");
      return;
    }
    if (!endDate) {
      setSnackbar("No se ha seleccionado fecha final.");
      return;
    }
    if (validateObject(station, true)) {
      setSnackbar("No se ha seleccionado alguna planta.");
      return;
    }
    if (!dayjs(startDate).isSameOrBefore(dayjs(endDate), "day")) {
      setSnackbar("La fecha final no puede ser menor a la inicial.");
      return;
    }
    if (dayjs(endDate).diff(dayjs(startDate), "day") > 30) {
      setSnackbar(
        "La fecha inicial no puede ser menor a 31 dias a la fecha final"
      );
      return;
    }
    if (endDate < startDate) {
      setSnackbar("La fecha final no puede ser mayor al día actual");
      return;
    }

    restoreTable(tableKey);
    dispatch(getUnitConfigs(station?.id));
    dispatch(getCarburation(station?.id, startDate, endDate));
  };

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
    buildCompLoadings([
      "loadingCarburations",
      "loadingCarburetionActions",
      "loadingUnitConfigs",
    ]);
  }, []);

  return (
    <React.Fragment>
      <CardTable
        hasHeader
        title="Carburaciones"
        columns={columns}
        data={carburations}
        isLoading={isLoadingComp?.loadingCarburations}
        icon={<LocalGasStation />}
        blockBtn
        hasControl
        tableContent={
          <>
          <TableInputs
            reducer="carburations"
            dates
            stations
            dispatchAction={carburationInputsSearch}
            submitAction={handleSubmit}
            />
            <Typography  variant="h6" color="info" style={{
              marginTop: 10,
              display: 'flex',
              justifyContent: 'flex-end',
              marginRight: 20,
              color: '#696969'
            }}>
              Consumo real: {formatNumber(realCarburetionTotal)} lts
            </Typography>
            </>
        }
        tableKey={tableKey}
        controls={
          <RegularButton
            round
            justIcon
            color="info"
            size="sm"
            onClick={setOpen}
          >
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      <ModalV2 toRight open={open} onClose={setOpen} title="Nueva carburación">
        <AddCarburetion onClose={setOpen} />
      </ModalV2>
    </React.Fragment>
  );
};
